import { render, staticRenderFns } from "./VaccineRemindersPopup.vue?vue&type=template&id=b64017ae&scoped=true&"
import script from "./VaccineRemindersPopup.vue?vue&type=script&lang=js&"
export * from "./VaccineRemindersPopup.vue?vue&type=script&lang=js&"
import style0 from "./VaccineRemindersPopup.vue?vue&type=style&index=0&id=b64017ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64017ae",
  null
  
)

export default component.exports